module.exports = __webpack_public_path__ + "static/media/dk.0e93a3b1.svg";